import { getRequestSettings, getCookie, setCookie, generateRandomString } from '_utils';

export function logActivity({
  activityType,
  activityValue1 = null,
  activityValue2 = null,
  activityValue3 = null,
  activityEmail = null,
  activityCulture = null,
}) {
  const activityParams = {
    activitySessionId: getSessionId(),
    activityType,
    activityValue1,
    activityValue2,
    activityValue3,
    activityEmail,
    activityCulture,
  };

  performPost(activityParams);
}

export function getSessionId() {
  const sessionCookieName = 'THUNDERBOLT_SESSION_COOKIE';

  let sessionId = getCookie(sessionCookieName);
  if (sessionId === '') {
    sessionId = generateRandomString(64);
    setCookie(sessionCookieName, sessionId);
  }

  return sessionId;
}

async function performPost(params) {
  const url = `${process.env.REACT_APP_API_ENDPOINT_BASE_URL}/api/thunderbolt/log-activity`;

  const res = await fetch(url, getRequestSettings('POST', params));
  if (!res.ok) {
    return false;
  }

  return res.ok;
}
